import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.29305 5.29303C3.00651 7.57957 1.86301 9.89683 1.61995 12.1275C1.39531 14.1892 1.9511 16.0747 2.92257 17.6706L2.52038 19.2175L2.51283 19.2645C2.30071 20.5849 3.45103 21.7217 4.76881 21.4941L4.81331 21.4864L6.33439 21.0796C7.92904 22.0453 9.81416 22.5982 11.8743 22.3743C14.1054 22.1318 16.4232 20.9913 18.7072 18.7073C20.9913 16.4232 22.1318 14.1054 22.3743 11.8743C22.5982 9.81417 22.0453 7.92906 21.0796 6.33441L21.4864 4.8133L21.4941 4.76879C21.7218 3.45101 20.5849 2.30069 19.2645 2.51282L19.2175 2.52036L17.6706 2.92258C16.0747 1.95112 14.1892 1.39532 12.1275 1.61995C9.89684 1.863 7.57959 3.00649 5.29305 5.29303ZM10.4126 7.58787L11.8295 6.1709L13.2465 7.58787L11.8295 9.00485L10.4126 7.58787ZM8.294 6.878L9.71098 8.29498L8.294 9.71196L6.87703 8.29498L8.294 6.878ZM7.5869 10.4135L9.00387 11.8305L7.5869 13.2475L6.16992 11.8305L7.5869 10.4135Z"}}]};

const LemonFilled = Vue.extend<IconProps>({
  name: 'LemonFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lemon-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LemonFilled;
